class MobileSubmenu extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.content = this.querySelector("[data-mega-menu-content]");
    this.menuContent = this.closest(".header__mobile-menu-content");

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggle();
    });

    this.closeButton = this.querySelector("[data-menu-close]");
    this.closeButton.addEventListener("click", () => this._close());
    document.addEventListener("mobile-menu:close", () => {
      this.details.open = false;
      this.details.classList.remove("open");
      window.removeTrapFocus(this.summary);
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.details.classList.contains("open")) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _open() {
    this.menuContent.style.overflow = "hidden";
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.details.classList.add("open");

      const onEnd = () => {
        this.removeEventListener("transitionend", onEnd);
        if (!this.details.classList.contains("open")) return;

        window.trapFocus(this.content, this.closeButton);
        this.dispatchEvent(
          new CustomEvent("mobile-submenu:open", { bubbles: true }),
        );
        this.menuContent.style.overflow = null;
      };

      this.addEventListener("transitionend", onEnd);
    });
  }

  _close() {
    this.menuContent.style.overflow = "hidden";
    this.details.classList.remove("open");
    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.details.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      this.dispatchEvent(
        new CustomEvent("mobile-submenu:close", { bubbles: true }),
      );
      this.menuContent.style.overflow = null;
    };
    this.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("mobile-submenu")) {
  customElements.define("mobile-submenu", MobileSubmenu);
}
